import {HttpClient} from '@angular/common/http';
import {AfterContentInit, Component, Input, SimpleChanges} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {ValgDialogService} from '@valg-shared/services/dialog/valg-dialog.service';
import {SvgIcon} from "@valg-shared/utils/svg-icon";
import {TipDialogData} from './tip-dialog/tip-dialog';
import {TipDialogComponent} from './tip-dialog/tip-dialog.component';

@Component({
  selector: 'valg-tip',
  templateUrl: './tip.component.html',
  styleUrls: [ './tip.component.scss' ]
})
export class TipComponent implements AfterContentInit{
  SvgIcon = SvgIcon;
  @Input() data: TipDialogData | undefined; 
  @Input() showText = true; 
  
  constructor(private readonly translate: TranslateService,
    public dialog: ValgDialogService,
    private readonly http: HttpClient) { }

  ngAfterContentInit() {
    this.getDialogData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes['data']){
      this.getDialogData();
    }
  }

  getDialogData(){
    if(this.data?.path){
      const path = `assets/help/${this.data.userAuthority}/${this.data.path}.html`;
      this.http.get(path, { responseType: "text" }).subscribe({ next: (data) => {
        if(this.data){
          this.data.content = data;
        }
      }, 
      error: () => {
          this.data = undefined;
      } });
    }
  }

  openDialog(): void {
    this.dialog.open(TipDialogComponent, {
      data: this.data,
      restoreFocus: true
    });
  }
}
